import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import { styled } from '../../styles/stitches.config';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const FounderSection = () => {

    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "rachelfounder" }) {
              childImageSharp {
                  gatsbyImageData
              }
            }
          }
        `
    )

    const image = getImage(data.allFile);

    const RachelSection = styled('section', {
        paddingBottom: '80px',
        paddingRight: '20px',
        display: 'grid',
        gridTemplateColumns: '3fr 4fr',
        fontFamily: '$lato',
        gap: '120px',
        img: {
            borderRadius: '0 !important',
        },
        '@bp1': {
            gridTemplateColumns: '1fr',
            paddingRight: '0px',
            gap: '0px',
        },
        p: {
            fontFamily: '$lato',
            fontSize: '18px',
            lineHeight: '29px',
            color: '#585d6c',
            maxWidth: '650px',
            margin: '0 0 20px 0',
        },
        '& .founderDetails': {
            '@bp1': {
                padding: '0 20px',
            },
        },
        '& h3': {
            marginTop: '80px',
            fontSize: '16px',
            marginBottom: '12px',
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '.1em',
            '@bp1': {
                marginTop: '40px',
            },
        },
        '& h2': {
            fontFamily: '$default',
            fontSize: '48px',
            lineHeight: '1.2',
            marginBottom: '20px',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
    });

    return (
        <RachelSection>
            <div>
                <div style={{ top: '0', position: 'sticky' }}>
                    <GatsbyImage image={image} alt={'blah'} />
                </div>
            </div>
            <div className="founderDetails">
                <h3>Founding Story</h3>
                <h2>Less, but Better</h2>
                <p>Better Days was born out of the frustration of not being able to find multi-tasking skincare products formulated for sensitive skin. As someone with easily sensitised skin that is prone to hormonal blemishes and dermatitis flare ups, I felt both overlooked and trapped by this industry. So I decided to bridge the gap.</p>
                <p>My personal experience with 10 step programs paired with highly concentrated single &quot;hero&quot; ingredient products ended up overwhelming my skin and created a cyclical process where my skin barrier was continuously compromised. This is why skin integrity is our utmost priority at Better Days, and our philosophy is to be as kind to our skin as possible.</p>
                <p>Skincare should be simple, safe and smart - it is essential to not use too many products. The key is to embrace multi-tasking products that can target several skin-enhancing pathways at the same time.</p>
                <p>Our Multi-Active Treatment Essence harnesses nourishing ingredients to deliver nutrients and treat our myriad of skin concerns with long term results. We excluded fragrance and fragrant essential oils because they are not always tolerated by those of us with sensitive conditions. It is a unique 7-in-1 multi-correctional formula that renews, brightens, hydrates, energises, firms, soothes and restores in one gentle step.</p>
                <p>Ultimately, our products are formulated to simplify routines so you can do better with less.</p>
            </div>
        </RachelSection>
    )
}

export default FounderSection
